import React from 'react'
import { Link } from 'react-router-dom'
import erimg from '../../images/error-404.png'
import { useLanguage } from '../../context/LanguageContext';

const Error = (props) => {
    const { t } = useLanguage();
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="error-404-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="content clearfix">
                            <div className="error">
                                <img src={erimg} alt="Sayfa Bulunamadı - 404 Hatası" />
                            </div>
                            <div className="error-message">
                                <h3>{t('error404.title')}</h3>
                                <p>{t('error404.desc')}</p>
                                <Link onClick={ClickHandler} to="/" className="theme-btn">{t('error404.btn')}</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Error;
